import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { WEB_ROUTES } from "../../../constants";
import { useGetAllReportPostsQuery } from "../../../Data/services/postReportApi";
import { baseRoute } from "../../../Helper";
import styles from "../styles/Dashboard.module.scss";
import { extractData, normalizeReportedPosts } from "../utils";

export default function ReportedPostsPanel() {
  const { data: reportsRes, isLoading } = useGetAllReportPostsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const reportedPosts = useMemo(
    () => normalizeReportedPosts(extractData(reportsRes)),
    [reportsRes]
  );

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <h5 className={styles.panelTitle}>Reported posts</h5>
        <p className={styles.panelHint}>
          {isLoading ? "Loading…" : `${reportedPosts.length} open reports`}
        </p>
      </div>
      {reportedPosts.length === 0 ? (
        <div className={styles.emptyState}>
          {isLoading ? "Loading reports…" : "No reported posts."}
        </div>
      ) : (
        <ul className={styles.reportList}>
          {reportedPosts.slice(0, 6).map((item, idx) => {
            const postText =
              item?.reportee?.post?.post_description ||
              item?.reportee?.post?.postTitle ||
              item?.title ||
              item?.post_title ||
              "";
            const reportMessage = item?.message || item?.reason || "";
            const title = (postText || reportMessage || "Untitled report").trim();
            const truncatedTitle =
              title.length > 72 ? `${title.slice(0, 72)}…` : title;
            const truncatedMessage =
              reportMessage && reportMessage !== postText
                ? reportMessage.length > 64
                  ? `${reportMessage.slice(0, 64)}…`
                  : reportMessage
                : item?.status || "Reported";

            return (
              <li key={item.slug || item.id || idx}>
                <div className={styles.reportCopy}>
                  <span className={styles.reportTitle}>{truncatedTitle}</span>
                  <span className={styles.reportMeta}>{truncatedMessage}</span>
                </div>
                {item?.status ? (
                  <span className={styles.mono}>{item.status}</span>
                ) : null}
              </li>
            );
          })}
        </ul>
      )}
      <Link
        to={baseRoute(WEB_ROUTES.POST_REPORT_MANAGEMENT)}
        className={styles.linkish}
      >
        Open post reports →
      </Link>
    </div>
  );
}
